// Permanent (301) redirect map for legacy URLs whose canonical destination
// has changed. Used by:
//  - src/routes/$.tsx           (splat) — for arbitrary legacy paths
//  - src/routes/ask-arif.$slug.tsx     — for renamed Ask Arif articles
//
// Format: "/legacy/path" -> "/canonical/path"
//
// Adding a redirect here is enough — both the splat route and the slug route
// pick it up automatically, and the SEO route-verification script
// (scripts/verify-seo-routes.mjs) treats these as known non-canonical paths.

export const REDIRECTS: Record<string, string> = {
  // Legacy top-level pages moved under /insights/*
  "/learning-center": "/insights/learning-centre",
  "/learning-centre": "/insights/learning-centre",
  "/media": "/insights/media",
  "/partners": "/insights/partners",
  "/insights/articles": "/insights/articles-guides",
  "/insights/guides": "/insights/articles-guides",

  // Legacy Insights slugs that were referenced in earlier hub copy but were
  // never published as real pages. Route them into the canonical Ask Arif
  // article that covers the same topic so any external links / cached crawls
  // resolve cleanly.
  "/insights/ai-in-perimeter-security-2030": "/ask-arif/how-does-perimeter-security-work",
  "/insights/luxury-home-cinema-checklist": "/ask-arif/common-mistakes-in-home-theatre-projects",
  "/insights/smart-building-roi-framework": "/ask-arif/what-is-an-intelligent-building",
  "/insights/perimeter-vs-cctv": "/ask-arif/how-does-perimeter-security-work",
  "/insights/smart-cities-future": "/ask-arif/what-is-an-intelligent-building",
  "/insights/home-automation-mistakes": "/ask-arif/how-much-does-home-automation-cost",

  // Legacy Ask Arif slugs that were renamed. Key = old slug only (no prefix);
  // resolveAskArifRedirect() handles the lookup.
  // Example (none active yet, but the mechanism is wired):
  // "automation-cost": "how-much-does-home-automation-cost",
};

/** Legacy Ask Arif slugs → current slug. Maintained alongside REDIRECTS. */
export const ASK_ARIF_LEGACY_SLUGS: Record<string, string> = {
  // Add renamed Ask Arif slugs here. Example:
  // "automation-cost": "how-much-does-home-automation-cost",
};

/** Returns the canonical path if `pathname` is a known legacy URL. */
export function resolveRedirect(pathname: string): string | null {
  const clean = pathname.replace(/\/$/, "") || "/";
  return REDIRECTS[clean] ?? null;
}

/** Returns the canonical Ask Arif slug if `slug` is a known legacy slug. */
export function resolveAskArifRedirect(slug: string): string | null {
  return ASK_ARIF_LEGACY_SLUGS[slug] ?? null;
}
